module.exports = __webpack_public_path__ + "img/img19.8022d18a.png";